import gql from 'graphql-tag';

import {
  GET_TIMESHEETS_FOR_PAYPERIOD,
  GET_WEEKLY_TIMESHEETS_HOURS_QUERY,
  WEEKLY_TIMESHEET_ENTRY_QUERY,
} from './index';

const UnapprovePayPeriodSummaryMutation = gql`
  mutation UnapprovePayPeriodSummary($input: RemoveGuaranteedTimeInput!) {
    pay_period_summary_remove_guaranteed_time(input: $input) {
      id
    }
  }
`;
export const unapprovePayPeriodSummarysApi = (
  client,
  userId,
  startOfWeek,
  supervisorId,
  payPeriodWeekId,
  userTimesheets,
) => {
  const variables = {
    input: {
      user_id: userId,
      pay_period_week_id: payPeriodWeekId,
    },
  };

  const userTimesheetsQueries = userTimesheets.map((ut) => {
    return {
      query: WEEKLY_TIMESHEET_ENTRY_QUERY,
      variables: {
        userId,
        originDate: ut.startDate.iso8601,
      },
    };
  });

  const options = {
    mutation: UnapprovePayPeriodSummaryMutation,
    variables,
    refetchQueries: [
      {
        query: GET_TIMESHEETS_FOR_PAYPERIOD,
        variables: {
          supervisorId,
          approvalState: 'unapproved',
        },
      },
      {
        query: GET_TIMESHEETS_FOR_PAYPERIOD,
        variables: {
          supervisorId,
          approvalState: 'approved',
        },
      },
      {
        query: GET_WEEKLY_TIMESHEETS_HOURS_QUERY,
        variables: {
          userId,
          originDate: startOfWeek,
        },
      },
      ...userTimesheetsQueries,
    ],
  };

  return client.mutate(options);
};
